/**
 * Return the relationship id from given relationships
 *
 * @export
 * @param {SohoModel} model
 * @param {*} relationships
 * @returns
 */
export function getRelationshipId(model: string, relationships: JsonApi.Relationships) {
  if (relationships) {
    const { data } = relationships[model] || {}
    if (!Array.isArray(data) && data && data.id) {
      return data.id
    }
  }

  return ''
}
